import { BulkRankActions } from '@bo-components/simulations/steps/StepThreeFinalize/BulkRankActions';
import { BulkTimePickers } from '@bo-components/simulations/steps/StepThreeFinalize/BulkTimePickers';
import { Button } from '@library/components/buttons';
import type { GamePlayerProjectionTrading } from '@library/types/trading';
import chevronDownIcon from '@library/assets/images/icons/chevron-down-icon.svg';
import { classNames } from '@library/utils';

export interface StatTypeHeaderProps {
  newAndChangedProjections: Array<GamePlayerProjectionTrading>;
  onBulkTimeChange: ({
    projectionBoardTime,
    projectionStartTime,
    simsProjections,
    updateProjection
  }: {
    simsProjections: Array<GamePlayerProjectionTrading>;
    projectionBoardTime?: string;
    projectionStartTime?: string;
    updateProjection: ({
      change,
      initialProjection
    }: {
      change: GamePlayerProjectionTrading;
      initialProjection: GamePlayerProjectionTrading;
    }) => void;
  }) => void;
  onToggleShowProjections: () => void;
  setSimProjections: (
    simsProjections: Array<GamePlayerProjectionTrading>
  ) => void;
  showProjections: boolean;
  simProjections: Array<GamePlayerProjectionTrading>;
  statTypeName: string;
  updateProjection: ({
    change,
    initialProjection
  }: {
    change: GamePlayerProjectionTrading;
    initialProjection: GamePlayerProjectionTrading;
  }) => void;
}

export const StatTypeHeader = ({
  newAndChangedProjections,
  onBulkTimeChange,
  onToggleShowProjections,
  setSimProjections,
  showProjections,
  simProjections,
  statTypeName,
  updateProjection
}: StatTypeHeaderProps) => {
  return (
    <div className="bg-soFresh-120 border-soFresh-140 font-heebo text-soClean-100 box-border flex h-16 min-h-16 w-full flex-row items-center justify-between px-4 text-base font-medium leading-6">
      <span>{statTypeName}</span>
      <div className="flex gap-4">
        <BulkRankActions
          newAndChangedProjections={newAndChangedProjections}
          setSimProjections={setSimProjections}
          simProjections={simProjections}
          statTypeName={statTypeName}
          updateProjection={updateProjection}
        />
        <BulkTimePickers
          simProjections={simProjections}
          updateProjection={updateProjection}
          onBulkTimeChange={onBulkTimeChange}
        />
        <Button
          type="button"
          title="ToggleGameTeamPlayersButton"
          onClick={onToggleShowProjections}
        >
          <img
            alt="Chevron Down icon"
            className={classNames(showProjections ? 'rotate-180' : '')}
            src={chevronDownIcon}
          />
        </Button>
      </div>
    </div>
  );
};
